<template>
  <button
    @click.prevent="setTenantAndNavigate"
    class="tc-card"
    :aria-label="`Open ${source.tenant_name}`"
    :title="source.tenant_name"
  >
    <div class="tc-card__content">
      <div v-if="source.image_url" class="tc-card__img-wrap">
        <img
          :src="source.image_url"
          :alt="`${source.tenant_name} logo`"
          class="tc-card__img"
        />
      </div>
      <div v-else class="tc-card__placeholder">
        <h3 class="tc-card__name">{{ source.tenant_name }}</h3>
      </div>
    </div>
    <ChevronRightIcon
      class="tc-card__chevron"
      aria-hidden="true"
    />
  </button>
</template>

<script>
import {mapMutations} from "vuex";
import { ChevronRightIcon } from '@heroicons/vue/solid'

export default {
  name: "tenantCard",
  components:{
    ChevronRightIcon
  },
  props: {
    index: { // index of current item
      type: Number
    },
    source: { // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    ...mapMutations(["setActiveTenantId"]),
    async setTenantAndNavigate() {
      await this.setActiveTenantId({ newTenantID: this.source.id, newTenantURL: this.source.tenant_url });
      await this.$nextTick();
      this.$emit('select', this.source);
    }
  }
}
</script>

<style scoped>
.tc-card {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem;
  cursor: pointer;
  font-family: 'Barlow', sans-serif;
  transition: background 0.18s;
}
.tc-card:focus {
  outline: none;
}
.tc-card:hover,
.tc-card:focus {
  background: rgb(0, 146, 191, 0.16);
}

.tc-card__content { flex: 1; min-width: 0; }

.tc-card__img-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 5rem;
}
.tc-card__img { height: 5rem; width: 100%; object-fit: contain; }

.tc-card__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 5rem;
  border-radius: 3px;
  /* background: rgba(0, 146, 191, 0.07); */
  /* border: 1px solid rgba(0, 146, 191, 0.14); */
  transition: background 0.3s, border-color 0.3s;
}
/* [data-theme="light"] .tc-card__placeholder {
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.10);
} */
[data-theme="light"] .tc-card {
  background: transparent;
}
[data-theme="light"] .tc-card:hover,
[data-theme="light"] .tc-card:focus {
  background: rgba(0, 0, 0, 0.04);
}
.tc-card__name {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--cc-tc-name);
  text-align: center;
  padding: 0 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  transition: color 0.3s;
}
.tc-card:focus .tc-card__name,
.tc-card:hover .tc-card__name {
  color: rgb(0, 145, 193);
}
[data-theme="dark"] .tc-card:focus .tc-card__name,
[data-theme="dark"] .tc-card:hover .tc-card__name {
  color: rgb(110, 219, 255);
}

.tc-card__chevron {
  width: 1.125rem;
  height: 1.125rem;
  color: rgb(103, 103, 103);
  flex-shrink: 0;
  transition: color 0.18s, transform 0.18s;
}
[data-theme="light"] .tc-card:focus .tc-card__chevron,
[data-theme="light"] .tc-card:hover .tc-card__chevron {
  color: rgb(0, 105, 140);
  transform: translateX(2px);
}
.tc-card:hover .tc-card__chevron,
.tc-card:focus .tc-card__chevron {
  color: rgb(97, 218, 255);
  transform: translateX(2px);
}
</style>